import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { BreakdownUnsaveChangeModal } from '../../types/breakdown-unsave-change-modal.types';

@Component({
  selector: 'muni-shared-breakdown-form-modal-confirm',
  templateUrl: './breakdown-form-confirm-modal.component.html',
  styleUrls: [
    './breakdown-form-confirm-modal.component.scss'
  ]
})
export class BreakdownFormConfirmModalComponent {
  public title: string;
  public message: string;
  public leaveBtnText: string;
  public cancelBtnText: string;

  @Input() set context(trans: BreakdownUnsaveChangeModal) {
    this.title = trans.title;
    this.message = trans.message;
    this.leaveBtnText = trans.leaveBtnText;
    this.cancelBtnText = trans.cancelBtnText;
  };

  @Input() response: Subject<unknown>;

  public closeModal(): void {
    this.response.next({
      closeAllowed: false
    });
    this.response.complete();
  }

  public leavePage(): void {
    this.response.next({
      closeAllowed: true
    });
    this.response.complete();
  }
}